<template>
  <v-container>
    <v-row>
      <v-col cols="12" >
        <v-img
          :src="require('@/assets/banner-finantare.png')"
          class="mx-auto"
          contain
          max-height="100px">
        </v-img>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <p class="text-center">
          CONȚINUTUL MATERIALELOR PUBLICATE PE ACEST SITE NU REPREZINTĂ ÎN MOD OBLIGATORIU POZIȚIA OFICIALĂ A UNIUNII EUROPENE SAU A GUVERNULUI ROMÂNIEI.
        </p>
      </v-col>
    </v-row>

    <v-row v-if="allResources.length">
      <v-col cols="12">
        <h1 class="text-h4 text-center">Resurse utile</h1>
        <v-slide-group
          v-model="resursa"
          class="pa-4"
          show-arrows>
          <v-slide-item v-slot:default="{ active, toggle }" v-for="item in allResources" :key="item._id">
            <v-hover v-slot:default="{ hover }">
              <v-card
                :color="active ? 'primary lighten-2' : 'grey lighten-4'"
                class="ma-4"
                :elevation="hover ? 4 : 2"
                height="200"
                width="200"
                @click="toggle">
                <v-img
                  :class="{ 'card-image-hover': hover || active }"
                  class="primary--text align-end card-image"
                  height="200px"
                  :src="item.thumb ? `${SERVER_URL}${item.thumb}` : require('@/assets/pptx.png')">
                  <v-expand-transition>
                    <div
                      v-if="hover"
                      class="d-flex transition-fast-in-fast-out primary v-card--reveal text-h4 text-center white--text"
                      style="height: 100%;">
                      {{ item.title }}
                    </div>
                  </v-expand-transition>
                </v-img>
                <!-- <v-row class="fill-height" align="center" justify="center">
                  <v-scale-transition>
                    <v-icon
                      v-if="active"
                      color="white"
                      size="48"
                      v-text="'mdi-close-circle-outline'">
                    </v-icon>
                  </v-scale-transition>
                </v-row> -->
              </v-card>
            </v-hover>
          </v-slide-item>
        </v-slide-group>

        <v-expand-transition>
          <v-sheet color="grey lighten-4" tile>
            <template v-if="resursa !== null && resursa !== undefined">
              <div class="ma-0 pa-2" align="center" justify="center">
                <h3 class="title">
                  {{ allResources[resursa].title }}
                </h3>
                <div v-html="allResources[resursa].content" class="text-left"></div>
                <a :href="SERVER_URL + allResources[resursa].file" target="_blank" download v-if="allResources[resursa].file" style="text-decoration: none">
                  Descarca
                  <v-icon right color="primary">
                    mdi-download
                  </v-icon>
                </a>
              </div>
            </template>
            <template v-else>
              <div class="ma-0 pa-2" align="center" justify="center">
                <h3 class="title">
                  Resurse
                </h3>
                <p>
                  Click pe o resursă pentru a putea vedea informații despre ea și pentru a o putea descărca.
                </p>
              </div>
            </template>
          </v-sheet>
        </v-expand-transition>
      </v-col>
    </v-row>
    <v-row v-if="allFaq.length">
      <v-col cols="12">
        <h1 class="text-h4 text-center">Întrebări frecvente</h1>
      </v-col>
    </v-row>
    <v-row v-if="allFaq.length">
      <v-col cols="12">
        <v-expansion-panels>
          <v-expansion-panel v-for="faq in allFaq" :key="faq._id">
            <v-expansion-panel-header>
              {{ faq.title }}
            </v-expansion-panel-header>
            <v-expansion-panel-content class="pa-2">
              <div v-html="faq.content"></div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" >
        <v-img
          :src="require('@/assets/parteneri.png')"
          class="mx-auto"
          contain
          max-height="60px">
        </v-img>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SERVER_URL from '@/config'

export default {
  name: 'AboutComponent',

  data: () => ({
    SERVER_URL,
    resursa: null
  }),

  computed: {
    allFaq () {
      return this.$store.getters.faqAllItems
    },
    allResources () {
      return this.$store.getters.resourcesAllItems
    }
  },

  beforeMount () {
    this.$store.dispatch('fetchAllFaq')
    this.$store.dispatch('fetchAllResources')
  }
}
</script>
